export default __webpack_public_path__ + "static/media/CD.7e09207a.svg";